module.exports = __webpack_public_path__ + "static/media/pp_clear_gaint_straw3.7cfdd97e.png";